import React, { useState, useEffect } from "react";
import { useSnackbar } from "notistack";
import {
  Row,
  Col,
  Spinner,
  Button,
  Label,
  Input,
  FormFeedback,
  Form,
  FormGroup,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  InputGroup,
  InputGroupText,
  Tooltip,
  ButtonToggle,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  UPLOAD_FILE,
  STATE_LIST,
  CREATE_AGENCY_USER,
  UPDATE_AGENCY_USER,
  LOOKUP_BY_EMAIL_FOR_AGENCY,
  DECRYPT_PASSWORD_URL,
} from "../../../constants/ApiPaths";
import { authHeader } from "../../../functions/CoreFunctions";
import API from "../../../redux/actions/API";
import { CustomAlertMessage } from "../../../functions/CustomFunctions";
import CustomPageLoading from "../../CustomComponents/CustomPageLoading";
import ProfileAvatar from "../../../constants/Images/defaultAvatar-1.png";
import {  NUMBER_REGEX } from "../../../constants/ValidationRegex";
import Iconawesomeeye from "../../../images/Iconawesomeeye.svg";
import Iconionicmdeyeoff from "../../../images/Iconionicmdeyeoff.svg";

export default function AgencyCustomerModal(props) {
  const {
    agencyId,
    CustomerModal,
    setCount,
    flag,
    Emaildisable,
    Count,
    formdata,
    CustomerModalToogle,
    lookupMail,
    setLookupMail,
  } = props;
  const { enqueueSnackbar } = useSnackbar();
  const [SelectState, setSelectState] = useState([]);
  const [Loading, setLoading] = useState(false);
  const [passwordShown, setPasswordShown] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState(false);
 
  const toggleTooltip = () => {
    setTooltipOpen(!tooltipOpen);
  };
  const togglePassword = () => {
    setPasswordShown(passwordShown ? false : true);
  };
  useEffect(() => {
    GetState();
  }, []);

  let GetState = async () => {
    setLoading(true);
    const config = {
      method: "Get",
      url: STATE_LIST,
      headers: authHeader(),
    };
    try {
      const response = await API(config);
      const { status, data } = response.data;
      if (status === "Success") {
        setSelectState(data);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };
  // validation schema
  Yup.addMethod(Yup.string, "phoneNumberValidation", function (errorMessage) {
    return this.test(`test-card-type`, errorMessage, function (value) {
      const { path, createError } = this;
      if (value) {
        let v1 = value;
        if (value.includes("+1 ")) {
          v1 = value.split("+1 ")[1];
        } else {
          // Handle the case where "+1 " is not present
          v1 = value;
        }

        var num = v1.replace(/\D+/g, "");
        var check = v1.match(/[A-Za-z_@./#&+!^*+=,:;]/) ? false : true;
        let Pass = num.length <= 10;
        return (check && Pass) || createError({ path, message: errorMessage });
      } else {
        return createError({ path, message: "Phone Number is Required" });
      }
    });
  });

  const validationSchema = Yup.object().shape({
    email: Yup.string().email("Invalid email").required("Email Required"),
    firstName: Yup.string().required("FirstName Required"),
    lastName: Yup.string().required("LastName Required"),
    phoneNumber: Yup.string().phoneNumberValidation("Invalid Phone Number"),
    // dateOfBirth: Yup.date().max(today, "Enter valid Date"),
    zip: Yup.string()
      .matches(NUMBER_REGEX, "Zip is not valid")
      .max(6, "Zip is not valid"),
    password: Yup.string().required("Password is required"),
  });
  const {
    handleSubmit,
    handleChange,
    touched,
    values,
    handleBlur,
    setValues,
    errors,
    resetForm,
  } = useFormik({
    initialValues: formdata,
    enableReinitialize: true,
    validationSchema,
    onSubmit: (values) => CreateEmployee(values),
  });
  const generatePass = () => {
    let pass = "";
    let str =
      ("ABCDEFGHIJKLMNOPQRSTUVWXYZ").concat("abcdefghijklmnopqrstuvwxyz0123456789@#$");

    for (let i = 1; i <= 8; i++) {
      let char = Math.floor(Math.random() * str.length + 1);

      pass += str.charAt(char);
    }

    setValues({ ...values, password: pass });
  };

  let CreateEmployee = async () => {
    setLoading(true);
    // const configpass = {
    //   method: "PUT",
    //   url: CHANGE_PASSWORD,
    //   data: {
    //     oldPassword: oldPassword,
    //     newPassword: values.password,
    //     email: values.email,
    //     hyperlink: window.location.host,
    //   },
    //   headers: authHeader(),
    // };

    // try {
    //   const response = await API(configpass);
    //   const { status, data } = response.data;

    //   if (status === "Success") {
    //     console.log("success");
    //   }
    // } catch (error) {
    //   console.log(error);
    // }
    const config = {
      method: flag ? "POST" : "PUT",
      url: flag ? CREATE_AGENCY_USER : UPDATE_AGENCY_USER,
      data: {
        ...values,
        agencyId: agencyId,
        roleId: 3,
        phoneNumber: values.phoneNumber.includes("+1")
          ? values.phoneNumber.split("+1 ")[1]
          : values.phoneNumber,
      },

      headers: authHeader(),
    };
    try {
      const response = await API(config);
      const { status } = response.data;
      if (status === "Success") {
        resetForm({});
        CustomerModalToogle();
        setCount(Count + 1);
        setLoading(false);
        setPasswordShown(false);
        CustomAlertMessage(
          flag ? "Employee Added Sucessfully!" : "Details Update Sucessfully!",
          "success",
          enqueueSnackbar
        );
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        CustomAlertMessage(data.message, "error", enqueueSnackbar);
      }
    } finally {
      setLoading(false);
    }
  };

  let Change = async (e) => {
    setLoading(true);
    e.preventDefault();
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const formDat = new FormData();
      formDat.append("file", selectedFile);
      const config = {
        method: "POST",
        url: UPLOAD_FILE,
        data: formDat,
        headers: authHeader(),
      };
      try {
        const response = await API(config);
        const { status, filePath } = response.data;
        if (status === "Success") {
          setValues({ ...values, profileImage: filePath });
          setLoading(false);
        }
      } catch (error) {
        if (error.response) {
          let { data } = error.response;
          CustomAlertMessage(data.message, "error", enqueueSnackbar);
        }
      } finally {
        setLoading(false);
      }
    }
  };

  let Profile = () => {
    const image = values.profileImage;
    if (image) {
      return image;
    } else {
      return ProfileAvatar;
    }
  };
  const getDecrypted = async (password) => {
    const config = {
      method: "POST",
      headers: authHeader(),
      url: DECRYPT_PASSWORD_URL,
      data: {
        encrypt: password,
      },
    };
    try {
      const response = await API(config);
      if (response) {
        console.log("success", response);
        // ps = response.data;
        return response.data;
      }
    } catch (error) {
      console.error(error);
    }
  };
 
  console.log("values", values);
  const lookUpFun = async () => {
    console.log("called", lookupMail);
    if (lookupMail !== "") {
      setLoading(true);
      const config = {
        method: "GET",
        url: LOOKUP_BY_EMAIL_FOR_AGENCY,
        params: {
          email: lookupMail,
        },
      };
      try {
        const response = await API(config);
        console.log(response.data.data[0]);
        const {
          address,
          city,
          email,
          firstName,
          lastName,
          password,
          phoneNumber,
          stateId,
          zip,
          roleId,
        } = response.data.data[0];
        let decryptedPassword;
        if (password !== "") {
          decryptedPassword = await getDecrypted(password);
          setValues({ ...values, password: decryptedPassword });
        }
        setValues({
          firstName,
          lastName,
          email,
          password: decryptedPassword,
          phoneNumber,
          address,
          stateId,
          city,
          zip,
          roleId,
        });
      } catch (error) {
        if (error) {
          const {  message } = error.response.data;
          CustomAlertMessage(message, "error", enqueueSnackbar);
        }
        console.error(error);
      } finally {
        setLoading(false);
      }
    }
  };
  const handleChangeFun = (e) => {
    setLookupMail(e.target.value);
  };
  return (
    <div>
      {Loading && <CustomPageLoading />}
      <Modal
        size="lg"
        isOpen={CustomerModal}
        toggle={() => {
          resetForm({});
          setPasswordShown(false); // Assuming setPasswordShown is used to hide the password
          CustomerModalToogle();
        }}
      >
        <Form form="true" onSubmit={handleSubmit}>
          <ModalHeader
            toggle={() => {
              resetForm({});
              setPasswordShown(false); // Assuming setPasswordShown is used to hide the password
              CustomerModalToogle();
            }}
          >
            {flag ? "Create agency admin" : "Update agency admin"}
          </ModalHeader>
          <ModalBody>
            <div className="user-box">
              <img value={values.profileImage} src={Profile()} alt=""/>
              <p>Profile</p>

              <div className="upload-btn-wrapper">
                <button className="upload-btn">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="19.407"
                    height="16.981"
                    viewBox="0 0 19.407 16.981"
                  >
                    <path
                      id="Icon_awesome-camera"
                      data-name="Icon awesome-camera"
                      d="M19.407,6.5V17.412a1.82,1.82,0,0,1-1.819,1.819H1.819A1.82,1.82,0,0,1,0,17.412V6.5A1.82,1.82,0,0,1,1.819,4.676H5.155l.466-1.247a1.817,1.817,0,0,1,1.7-1.179H12.08a1.817,1.817,0,0,1,1.7,1.179l.47,1.247h3.336A1.82,1.82,0,0,1,19.407,6.5Zm-5.155,5.458A4.549,4.549,0,1,0,9.7,16.5,4.552,4.552,0,0,0,14.252,11.954Zm-1.213,0A3.336,3.336,0,1,1,9.7,8.618,3.341,3.341,0,0,1,13.039,11.954Z"
                      transform="translate(0 -2.25)"
                      fill="#d51d1d"
                    />
                  </svg>
                </button>
                <Input type="file" name="profileImage" onChange={Change} />
              </div>
            </div>
            {flag ? (
              <Row xs="12">
                <Col xs="6">
                  <FormGroup>
                    <Label for="">Email</Label>
                    <Input
                      type="email"
                      value={lookupMail}
                      onBlur={handleBlur}
                      // disabled={Emaildisable}
                      // invalid={errors.email && touched.email ? true : false}
                      onChange={handleChangeFun}
                      id=""
                      placeholder="Enter email"
                    />
                    {/* <FormFeedback>
                    {errors.email && touched.email ? errors.email : ""}
                  </FormFeedback> */}
                  </FormGroup>
                </Col>
                <Col xs="6">
                  <ButtonToggle
                    style={{ marginTop: "30px" }}
                    // form={`endUserWebForm_${currentStep}`}
                    // type="submit"
                    color="primary"
                    onClick={lookUpFun}
                  >
                    {/* {loading && <CustomButtonLoader loading={loading} />} */}

                    {"Look Up"}
                  </ButtonToggle>
                </Col>
              </Row>
            ) : (
              <></>
            )}
            <Row xs="12">
              <Col xs="6">
                <FormGroup>
                  <Label for="">First Name</Label>
                  <Input
                    type="text"
                    name="firstName"
                    value={values.firstName}
                    onBlur={handleBlur}
                    invalid={
                      errors.firstName && touched.firstName ? true : false
                    }
                    onChange={handleChange}
                    id=""
                    placeholder="Enter first name"
                  />
                  <FormFeedback>
                    {errors.firstName && touched.firstName
                      ? errors.firstName
                      : ""}
                  </FormFeedback>
                </FormGroup>

                <FormGroup>
                  <Label for="">Email</Label>
                  <Input
                    type="email"
                    name="email"
                    value={values.email}
                    onBlur={handleBlur}
                    disabled={Emaildisable}
                    invalid={errors.email && touched.email ? true : false}
                    onChange={handleChange}
                    id=""
                    placeholder="Enter email"
                  />
                  <FormFeedback>
                    {errors.email && touched.email ? errors.email : ""}
                  </FormFeedback>
                </FormGroup>
                {/* <FormGroup>
                  <Label for="">Date of Birth</Label>
                  <Input
                    type="date"
                    name="dateOfBirth"
                    value={moment(values.dateOfBirth).format("YYYY-MM-DD")}
                    onBlur={handleBlur}
                    invalid={
                      errors.dateOfBirth && touched.dateOfBirth ? true : false
                    }
                    onChange={handleChange}
                    placeholder="hjh"
                    id=""
                  />
                  <FormFeedback>
                    {errors.dateOfBirth && touched.dateOfBirth
                      ? errors.dateOfBirth
                      : ""}
                  </FormFeedback>
                </FormGroup> */}
                <FormGroup>
                  <Label for="">Phone Number</Label>
                  <Input
                    type="text"
                    name="phoneNumber"
                    value={values.phoneNumber}
                    onBlur={handleBlur}
                    invalid={
                      errors.phoneNumber && touched.phoneNumber ? true : false
                    }
                    onChange={handleChange}
                    id=""
                    placeholder="Enter phone number"
                  />
                  <FormFeedback>
                    {errors.phoneNumber && touched.phoneNumber
                      ? errors.phoneNumber
                      : ""}
                  </FormFeedback>
                </FormGroup>

                {flag ? (
                  <FormGroup>
                    <Label for="">State</Label>

                    <Input
                      type="select"
                      name="stateId"
                      value={values.stateId}
                      onBlur={handleBlur}
                      invalid={errors.stateId && touched.stateId ? true : false}
                      onChange={handleChange}
                      id=""
                      placeholder="Enter hyperlink"
                    >
                      <option value="">Select State</option>
                      {SelectState.map((i) => (
                        <option key={i.stateId} value={i.stateId}>
                          {i.stateName}
                        </option>
                      ))}
                    </Input>
                    <FormFeedback>
                      {errors.stateId && touched.stateId ? errors.stateId : ""}
                    </FormFeedback>
                  </FormGroup>
                ) : (
                  <></>
                )}

                {!flag ? (
                  <FormGroup>
                    <Label for="">State</Label>

                    <Input
                      type="select"
                      name="stateId"
                      value={values.stateId}
                      onBlur={handleBlur}
                      invalid={errors.stateId && touched.stateId ? true : false}
                      onChange={handleChange}
                      id=""
                      placeholder="Enter hyperlink"
                    >
                      <option value="">Select State</option>
                      {SelectState.map((i) => (
                        <option key={i.stateId} value={i.stateId}>
                          {i.stateName}
                        </option>
                      ))}
                    </Input>
                    <FormFeedback>
                      {errors.stateId && touched.stateId ? errors.stateId : ""}
                    </FormFeedback>
                  </FormGroup>
                ) : (
                  <></>
                )}
                <FormGroup>
                  <Label for="">Zip</Label>
                  <Input
                    type="text"
                    name="zip"
                    value={values.zip}
                    onBlur={handleBlur}
                    invalid={errors.zip && touched.zip ? true : false}
                    onChange={handleChange}
                    id=""
                    placeholder="Enter zip Code"
                  />
                  <FormFeedback>
                    {errors.zip && touched.zip ? errors.zip : ""}
                  </FormFeedback>
                </FormGroup>
              </Col>
              <Col xs="6">
                <FormGroup>
                  <Label for="">Last Name</Label>
                  <Input
                    type="text"
                    name="lastName"
                    value={values.lastName}
                    onBlur={handleBlur}
                    invalid={errors.lastName && touched.lastName ? true : false}
                    onChange={handleChange}
                    id=""
                    placeholder="Enter last name"
                  />
                  <FormFeedback>
                    {errors.lastName && touched.lastName ? errors.lastName : ""}
                  </FormFeedback>
                </FormGroup>

                <FormGroup>
                  <Label for="">Password</Label>
                  <InputGroup>
                    <Input
                      type={passwordShown ? "text" : "password"}
                      name="password"
                      id="password"
                      value={values.password}
                      onBlur={handleBlur}
                      invalid={
                        errors.password && touched.password ? true : false
                      }
                      onChange={handleChange}
                      placeholder="Enter password"
                    />
                    <>
                      <InputGroupText
                        onClick={togglePassword}
                        style={{ cursor: "pointer" }}
                      >
                        {passwordShown ? (
                          <img src={Iconawesomeeye} alt=""/>
                        ) : (
                          <img src={Iconionicmdeyeoff} alt=""/>
                        )}
                      </InputGroupText>
                    </>
                    <Tooltip
                      placement="left"
                      isOpen={tooltipOpen}
                      target="keyIcon"
                      toggle={toggleTooltip}
                    >
                      Generate password
                    </Tooltip>
                    <i
                      id="keyIcon"
                      style={{
                        margin: "auto",
                        paddingLeft: "8px",
                        cursor: "pointer",
                      }}
                      class="fas fa-key"
                      onClick={generatePass}
                    ></i>
                  </InputGroup>
                  <FormFeedback>
                    {errors.password && touched.password ? errors.password : ""}
                  </FormFeedback>
                </FormGroup>

                {/* <FormGroup>
                  <Label for="">Gender</Label>
                  <Input
                    type="select"
                    name="gender"
                    value={values.gender}
                    onBlur={handleBlur}
                    invalid={errors.gender && touched.gender ? true : false}
                    onChange={handleChange}
                    id=""
                  >
                    <option value="">Select Gender</option>
                  </Input>
                  <FormFeedback>
                  </FormFeedback>
                </FormGroup> */}
                <FormGroup>
                  <Label for="">Address</Label>
                  <Input
                    type="text"
                    name="address"
                    value={values.address}
                    onBlur={handleBlur}
                    invalid={errors.address && touched.address ? true : false}
                    onChange={handleChange}
                    id=""
                    placeholder="Enter Your Address"
                  />
                  <FormFeedback>
                    {errors.address && touched.address ? errors.address : ""}
                  </FormFeedback>
                </FormGroup>
                <FormGroup>
                  <Label for="">City</Label>
                  <Input
                    type="text"
                    name="city"
                    value={values.city}
                    onBlur={handleBlur}
                    invalid={errors.city && touched.city ? true : false}
                    onChange={handleChange}
                    id=""
                    placeholder="Enter city name"
                  />
                  <FormFeedback>
                    {errors.city && touched.city ? errors.city : ""}
                  </FormFeedback>
                </FormGroup>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" type="submit" block>
              {Loading ? <Spinner color="primary" /> : ""}{" "}
              {flag ? "ADD" : "Update"}
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
}
